import { Fragment, createContext, useCallback, useContext, useEffect, useState } from "react";
import { useAuth } from "@/auth/AuthContext";
import es from "./es";

const DICTS = { es };
const KEY = "abs.lang";
export const LANGUAGES = [
  { value: "en", label: "English" },
  { value: "es", label: "Español" },
];

let currentLang = "en";
export const getLang = () => currentLang;
export function tr(s, vars) {
  let out = DICTS[currentLang]?.[s] ?? s;
  if (vars) for (const k of Object.keys(vars)) out = out.split(`{${k}}`).join(String(vars[k]));
  return out;
}

const Ctx = createContext({ lang: "en", t: tr });

export function I18nProvider({ children }) {
  const { user } = useAuth();
  const [local, setLocal] = useState(() => {
    try { return window.localStorage.getItem(KEY) || "en"; } catch { return "en"; }
  });
  const lang = DICTS[user?.language] || user?.language === "en" ? user.language : local;
  currentLang = lang;
  useEffect(() => {
    currentLang = lang;
    document.documentElement.lang = lang;
    if (user?.language) {
      setLocal(user.language);
      try { window.localStorage.setItem(KEY, user.language); } catch { /* storage disabled */ }
    }
  }, [lang, user?.language]);
  const t = useCallback((s, vars) => {
    let out = DICTS[lang]?.[s] ?? s;
    if (vars) for (const k of Object.keys(vars)) out = out.split(`{${k}}`).join(String(vars[k]));
    return out;
  }, [lang]);
  return <Ctx.Provider value={{ lang, t }}><Fragment key={lang}>{children}</Fragment></Ctx.Provider>;
}

export const useI18n = () => useContext(Ctx);
